import React from 'react';
import { Info } from 'lucide-react';
import Loader from 'src/shared/components/loader/Loader';
import MetricCard from 'src/shared/components/metric-card/MetricCard';
import QuestionButtonHelp from 'src/shared/components/question-button-help/QuestionButtonHelp';
import { useSpeciesMetricsQuery } from 'src/app/dashboard/state/metrics/metricsGraphSlice';
import { filterByGRIISList } from 'src/app/dashboard/components/metrics/metrics-table/metricsTableHelpers';
import useProjectFilters from 'src/shared/hooks/useProjectFilters';

const InvasiveMetrics = () => {
    const {
        currentProjectId,
        currentProjectSelectedHabitatAssayType: habitatAssayType,
        currentProjectSelectedDateRange,
    } = useProjectFilters();

    const { currentData, isFetching } = useSpeciesMetricsQuery(
        {
            projectId: currentProjectId || '',
            samples: {
                fromDate: currentProjectSelectedDateRange?.startDate,
                toDate: currentProjectSelectedDateRange?.endDate,
                habitatAssay: habitatAssayType?.key || '',
            },
        },
        {
            skip: !currentProjectId || !habitatAssayType || !currentProjectSelectedDateRange,
        }
    );

    if (!currentData || isFetching) {
        return <Loader />;
    }

    const { speciesMetrics: speciesMetricsData } = currentData;
    const { taxonomySummary } = speciesMetricsData;

    const invasiveLists = filterByGRIISList(taxonomySummary);

    return (
        <MetricCard
            header={'Invasive Species'}
            content='invasive species detected'
            helpText={<QuestionButtonHelp type='api' placement='right' slug='invasive-species' />}
            total={invasiveLists.length}
            logo={<Info style={{ color: '#E42322', marginRight: '5px', transform: 'rotate(180deg)' }} />}
        />
    );
};

export default InvasiveMetrics;
